var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "AddressPconment" },
    [
      _c(
        "van-cell-group",
        [
          _c("van-cell", {
            attrs: { title: "城市", "is-link": "", value: _vm.city },
            on: { click: _vm.onCity }
          }),
          _vm._v(" "),
          _c("van-cell", {
            attrs: { title: "地区", "is-link": "", value: _vm.district },
            on: { click: _vm.onDistrict }
          }),
          _vm._v(" "),
          _c("van-cell", {
            attrs: {
              title: "小区",
              "is-link": "",
              value: _vm.villageData.villageName
            },
            on: { click: _vm.onVillage }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        [
          _c("van-cell", {
            attrs: {
              title: "楼栋",
              "is-link": "",
              value: _vm.buildingData.buildingName
            },
            on: { click: _vm.onBuilding }
          }),
          _vm._v(" "),
          _c("van-cell", {
            attrs: {
              title: "单元",
              "is-link": "",
              value: _vm.unit ? _vm.unit : "请选择您所在的单元"
            },
            on: { click: _vm.onUnit }
          }),
          _vm._v(" "),
          _c("van-cell", {
            attrs: {
              title: "楼层",
              "is-link": "",
              value: _vm.floorNo ? _vm.floorNo : "请选择您所在的楼层"
            },
            on: { click: _vm.onFloor }
          }),
          _vm._v(" "),
          _c("van-cell", {
            attrs: {
              title: "室号",
              "is-link": "",
              value: _vm.roomNo ? _vm.roomNo : "请选择您所在的室号"
            },
            on: { click: _vm.onRoom }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-col",
        {
          staticClass: "barBtn",
          attrs: { span: "24", type: "flex", justify: "space-between" }
        },
        [
          _c(
            "van-button",
            {
              staticClass: "saveBth",
              attrs: {
                round: "",
                type: "danger",
                size: "large",
                disabled: _vm.isSave
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.UpdateInfo($event)
                }
              }
            },
            [_vm._v("去查询")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.isShow,
            callback: function($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow"
          }
        },
        [
          _c("van-picker", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isCity,
                expression: "isCity"
              }
            ],
            attrs: {
              "show-toolbar": "",
              columns: _vm.columns,
              "value-key": "regionName"
            },
            on: { confirm: _vm.onCityConfirm, cancel: _vm.cnacelShow }
          }),
          _vm._v(" "),
          _c("van-picker", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isDistrict,
                expression: "isDistrict"
              }
            ],
            attrs: {
              "show-toolbar": "",
              columns: _vm.columns,
              "value-key": "regionName"
            },
            on: {
              confirm: _vm.onDistrictConfirm,
              cancel: function($event) {
                _vm.isShow = false
              }
            }
          }),
          _vm._v(" "),
          _c("van-picker", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isUFRpop,
                expression: "isUFRpop"
              }
            ],
            attrs: {
              "show-toolbar": "",
              columns: _vm.BUFRinfo,
              "value-key": _vm.infoKey
            },
            on: {
              confirm: _vm.onUFRConfirm,
              cancel: function($event) {
                _vm.isShow = false
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.villageList
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isVillage,
                  expression: "isVillage"
                }
              ],
              staticClass: "popCon"
            },
            [
              _c(
                "van-index-bar",
                { attrs: { "index-list": _vm.indexList, sticky: "" } },
                _vm._l(_vm.indexList, function(index) {
                  return _c(
                    "div",
                    { key: index },
                    [
                      _c("van-index-anchor", { attrs: { index: index } }),
                      _vm._v(" "),
                      _vm._l(_vm.villageList, function(item) {
                        return _c(
                          "div",
                          [
                            item.villageNameS == index
                              ? _c("van-cell", {
                                  attrs: { title: item.villageName },
                                  on: {
                                    click: function($event) {
                                      return _vm.VillageSelect(
                                        item.villageId,
                                        item.villageName
                                      )
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                }),
                0
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2af9861e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2af9861e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/heatReportRepair/AddressCheck.vue
// module id = null
// module chunks = 